var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "certificate-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.58333 18.3333C6.24422 18.3333 4.57466 18.3333 3.53733 17.1129C2.5 15.8925 2.5 13.9283 2.5 9.99996C2.5 6.07159 2.5 4.1074 3.53733 2.88702C4.57466 1.66663 6.24422 1.66663 9.58333 1.66663C12.9224 1.66663 14.592 1.66663 15.6293 2.88702C16.4643 3.86939 16.6273 5.33374 16.659 7.91663",
    stroke: "#1C9BDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 6.66663H12.5003H6.66699ZM6.66699 10.8333H9.16699H6.66699Z",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 6.66663H12.5003M6.66699 10.8333H9.16699",
    stroke: "#1C9BDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.3413 15.0878C17.0437 14.5765 17.5003 13.7478 17.5003 12.8125C17.5003 11.2592 16.2412 10 14.6878 10H14.4795C12.9262 10 11.667 11.2592 11.667 12.8125C11.667 13.7478 12.1236 14.5765 12.826 15.0878M16.3413 15.0878C15.8772 15.4257 15.3058 15.625 14.6878 15.625H14.4795C13.8615 15.625 13.2901 15.4257 12.826 15.0878M16.3413 15.0878L16.827 16.617C17.0122 17.2002 17.1049 17.4919 17.0796 17.6735C17.0268 18.0514 16.7186 18.332 16.3547 18.3333C16.1798 18.334 15.9178 18.1965 15.3939 17.9216C15.1692 17.8037 15.0569 17.7447 14.942 17.71C14.7078 17.6394 14.4595 17.6394 14.2253 17.71C14.1104 17.7447 13.9981 17.8037 13.7734 17.9216C13.2495 18.1965 12.9875 18.334 12.8127 18.3333C12.4487 18.332 12.1405 18.0514 12.0877 17.6735C12.0624 17.4919 12.1551 17.2002 12.3403 16.617L12.826 15.0878",
    stroke: "#1C9BDB",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate01);
export default __webpack_public_path__ + "static/media/certificate_01.12d441ca93a9f39574d98fcd58bcea82.svg";
export { ForwardRef as ReactComponent };